export default {
  name: 'booksy-wallet',
  path: 'booksy-wallet/:path(.*)?',
  component: () => import('@/views/business/booksy-wallet/index.vue'),
}
